import React from 'react';
import { packageItems } from '../data/content';
export function PackageContents() {
  return <section className="w-full bg-cream-100 px-4 py-20" data-id="element-106" data-mp="son34gas0as1">
      <div className="mx-auto max-w-5xl" data-id="element-107" data-mp="sm0mlr5wqkxo">
        <h2 className="text-center font-display text-[26px] font-black leading-tight tracking-[-0.01em] text-ink sm:text-[32px]" data-id="element-108" data-mp="16g1kkip1c3wz">
          <span aria-hidden="true" data-id="element-109" data-mp="11n8iy3ov5bp4">📦</span> Cosa c&apos;è dentro il pacchetto SCIENZE PRONTA™?
        </h2>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-110" data-mp="1gc4r00qx6opq">
          {packageItems.map(item => <li key={item.title} className="flex h-full flex-col rounded-2xl border border-cream-300 bg-cream-200/70 p-6" data-id="element-111" data-mp="1bgpbl4d9kkr7">
              <span className="text-lg leading-none" aria-hidden="true" data-id="element-112" data-mp="1le3st670hdkk">
                {item.icon}
              </span>
              <h3 className="mt-4 font-display text-[16px] font-bold leading-snug text-ink" data-id="element-113" data-mp="3r60rcoucg6y0">
                {item.title}
              </h3>
              <p className="mt-1 font-sans text-[11px] font-semibold uppercase tracking-[0.12em] text-brand" data-id="element-114" data-mp="2safe9piw4faf">
                {item.subtitle}
              </p>
              <p className="mt-3 font-sans text-[12.5px] leading-relaxed text-ink-soft" data-id="element-115" data-mp="2x9i78blliv21">
                {item.text}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}